<div class="row" *ngFor="let a of answers$ | async">
  <div class="col-12">
    <ng-container *ngIf="checkedAnswers$ | async as checkedAnswers">
      <ng-container *ngIf="checkedAnswers.includes(a); then checkedTmpl; else uncheckedTmpl;"></ng-container>

      <ng-template #checkedTmpl>
        <mat-icon color="accent">{{ checkedIcon$ | async }}</mat-icon>
      </ng-template>
      <ng-template #uncheckedTmpl>
        <mat-icon color="accent">{{ unCheckedIcon$ | async }}</mat-icon>
      </ng-template>
    </ng-container>

    <span>{{a}}</span>
  </div>
</div>
